import { render, staticRenderFns } from "./VideoDialogue.vue?vue&type=template&id=4a30928e&scoped=true"
import script from "./VideoDialogue.vue?vue&type=script&lang=js"
export * from "./VideoDialogue.vue?vue&type=script&lang=js"
import style0 from "./VideoDialogue.vue?vue&type=style&index=0&id=4a30928e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30928e",
  null
  
)

export default component.exports